import React, { useState } from 'react';

const Contact = ({ lang }) => {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const labels = {
    fr: {
      title: 'Contact',
      name: 'Votre nom',
      email: 'Votre email',
      msg: 'Votre message',
      send: 'Envoyer',
      sending: 'Envoi...',
      success: 'Message envoyé avec succès !',
      error: 'Erreur lors de l\'envoi. Veuillez réessayer.'
    },
    en: {
      title: 'Contact',
      name: 'Your name',
      email: 'Your email',
      msg: 'Your message',
      send: 'Send',
      sending: 'Sending...',
      success: 'Message sent successfully!',
      error: 'Error sending message. Please try again.'
    }
  };

  const L = labels[lang];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);

    try {
      const res = await fetch('/api/v1/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      const data = await res.json();
      
      if (data.success) {
        setStatus('success');
        setForm({ name: '', email: '', message: '' });
      } else {
        setStatus('error');
      }
    } catch (err) {
      console.error(err);
      setStatus('error');
    }

    setLoading(false);
  };

  return (
    <div className="contact">
      <h1>✉️ {L.title}</h1>
      
      {status === 'success' && (
        <div className="alert success">{L.success}</div>
      )}
      {status === 'error' && (
        <div className="alert error">{L.error}</div>
      )}
      
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder={L.name}
          value={form.name}
          onChange={e => setForm({...form, name: e.target.value})}
          required
        />
        <input
          type="email"
          placeholder={L.email}
          value={form.email}
          onChange={e => setForm({...form, email: e.target.value})}
          required
        />
        <textarea
          placeholder={L.msg}
          value={form.message}
          onChange={e => setForm({...form, message: e.target.value})}
          required
        />
        <button type="submit" disabled={loading}>
          {loading ? L.sending : L.send}
        </button>
      </form>
    </div>
  );
};

export default Contact;
